import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VDataTable, {
    attrs: {
      "items": _vm.clonedDataPointsIndexes,
      "options": _vm.tableOptions,
      "headers": _vm.tableHeaders,
      "loading": _vm.isFetching,
      "footer-props": _vm.tableFooterProps,
      "item-key": "id"
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (items) {
        return [_c('tr', [_c('td', {
          staticClass: "px-0 text-center"
        }, [items.item && (items.item.duplicate || items.item.invalid || _vm.dataPoint.device && !items.item.device.variables) ? _c(VTooltip, {
          attrs: {
            "right": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function ({
              on
            }) {
              return [_c(VIcon, _vm._g({
                attrs: {
                  "color": "red",
                  "x-small": ""
                }
              }, on), [_vm._v("fal fa-exclamation-triangle")])];
            }
          }], null, true)
        }, [items.item.duplicate ? _c('span', [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.iecValidationErrors.uniqueAddressError')) + "\n            ")]) : _vm._e(), items.item.invalid ? _c('span', [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.iecValidationErrors.validAddress')) + "\n            ")]) : _vm._e(), _vm.dataPoint.device && !items.item.device.variables ? _c('span', [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.iecValidationErrors.validDevice')) + "\n            ")]) : _vm._e()]) : _vm._e(), _vm._v("\n          " + _vm._s(items.item.device.id) + "\n        ")], 1), _c('td', [_c('div', {
          staticStyle: {
            "width": "100px"
          }
        }, [_c('div', {
          staticClass: "text-truncate"
        }, [_vm._v("\n              " + _vm._s(items.item.device.title) + "\n            ")])])]), _c('td', [_vm._v(_vm._s(items.item.variable ? items.item.variable.variable : ''))]), _c('td', [_vm._v(_vm._s(items.item.ca))]), _c('td', [_vm._v(_vm._s(items.item.ioa))]), _c('td', [_vm._v(_vm._s(items.item.type))]), _c('td', [_vm._v(_vm._s(items.item.db))]), _vm.isIotHubManager ? _c('td', {
          staticClass: "text-right"
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": "",
            "title": "Delete"
          },
          on: {
            "click": function ($event) {
              return _vm.deleteItem(items.item.arrayIndex);
            }
          }
        }, [_vm._v("\n            fal fa-trash-alt\n          ")]), _vm._v("\n           \n          "), _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": "",
            "title": "Edit"
          },
          on: {
            "click": function ($event) {
              return _vm.editItem(items.item.arrayIndex);
            }
          }
        }, [_vm._v("fal fa-edit")])], 1) : _vm._e()])];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_vm._v("\n      " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n    ")];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n      ")])];
      },
      proxy: true
    }])
  }), _c(VDialog, {
    attrs: {
      "max-width": _vm.dialogWidth
    },
    model: {
      value: _vm.dialogAdd,
      callback: function ($$v) {
        _vm.dialogAdd = $$v;
      },
      expression: "dialogAdd"
    }
  }, [_c(VRow, {
    attrs: {
      "dense": ""
    }
  }, [_c(VCol, {
    attrs: {
      "cols": _vm.dialogCol
    }
  }, [_c(VCard, [_c(VCardTitle, {
    staticClass: "text-h5"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.iecDpConfig')))]), _c(VCardText, [_c(VForm, {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.isDpFormValid,
      callback: function ($$v) {
        _vm.isDpFormValid = $$v;
      },
      expression: "isDpFormValid"
    }
  }, [_c(VAutocomplete, {
    staticClass: "mt-4",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.chooseDevice') + ' *',
      "color": _vm.color,
      "loading": _vm.isFetchingDevices,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.devicesSelection,
      "item-text": "title",
      "hide-details": "auto",
      "return-object": "",
      "required": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(data.item.title))]), _c(VListItemSubtitle, [_vm._v("ID: " + _vm._s(data.item.id))])], 1)];
      }
    }]),
    model: {
      value: _vm.dataPoint.device,
      callback: function ($$v) {
        _vm.$set(_vm.dataPoint, "device", $$v);
      },
      expression: "dataPoint.device"
    }
  }), _c(VAutocomplete, {
    staticClass: "mt-4",
    attrs: {
      "disabled": !_vm.dataPoint.device.id,
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.chooseMeas') + ' *',
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.dataPoint.device.variables,
      "item-text": _vm.measurementVariable,
      "hide-details": "auto",
      "return-object": "",
      "required": ""
    },
    on: {
      "change": _vm.dpFormValidation
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(data.item ? data.item.variable : ''))]), _c(VListItemSubtitle, [_vm._v("\n                      Unit: " + _vm._s(data.item ? data.item.value_type_name : '') + "\n                    ")])], 1)];
      }
    }]),
    model: {
      value: _vm.dataPoint.variable,
      callback: function ($$v) {
        _vm.$set(_vm.dataPoint, "variable", $$v);
      },
      expression: "dataPoint.variable"
    }
  }), _c(VTextField, {
    staticClass: "mt-4",
    attrs: {
      "disabled": !_vm.dataPoint.device.id,
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.commonAddress') + ' *',
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "append-icon": 'fal fa-calculator',
      "type": "number",
      "min": "0",
      "rules": _vm.rules('CA'),
      "oninput": "validity.valid||(value='')",
      "required": ""
    },
    on: {
      "click:append": function ($event) {
        return _vm.toggleAddressCalculator('ca');
      },
      "input": function ($event) {
        return _vm.convertToNumber('ca');
      },
      "change": _vm.dpFormValidation
    },
    model: {
      value: _vm.dataPoint.ca,
      callback: function ($$v) {
        _vm.$set(_vm.dataPoint, "ca", $$v);
      },
      expression: "dataPoint.ca"
    }
  }), _c(VTextField, {
    staticClass: "mt-4",
    attrs: {
      "disabled": !_vm.dataPoint.device.id,
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.infObjAddress') + ' *',
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "append-icon": 'fal fa-calculator',
      "type": "number",
      "min": "0",
      "oninput": "validity.valid||(value='')",
      "rules": _vm.rules('IOA'),
      "required": ""
    },
    on: {
      "click:append": function ($event) {
        return _vm.toggleAddressCalculator('ioa');
      },
      "input": function ($event) {
        return _vm.convertToNumber('ioa');
      },
      "change": _vm.dpFormValidation
    },
    model: {
      value: _vm.dataPoint.ioa,
      callback: function ($$v) {
        _vm.$set(_vm.dataPoint, "ioa", $$v);
      },
      expression: "dataPoint.ioa"
    }
  }), _c(VAutocomplete, {
    staticClass: "mt-4",
    attrs: {
      "disabled": !_vm.dataPoint.device.id,
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.type') + ' *',
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.dptypes,
      "item-text": "typeString",
      "hide-details": "auto",
      "rules": _vm.rules(_vm.$i18n_t('NiotaClassic.Consumers.detail.type')),
      "return-object": "",
      "required": ""
    },
    on: {
      "input": _vm.setDataPointType,
      "change": _vm.dpFormValidation
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(data.item.typeString))]), _c(VListItemSubtitle, [_c('span', {
          staticClass: "font-weight-medium"
        }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.decimal')))]), _vm._v("\n                      " + _vm._s(data.item.type) + "\n                    ")]), _c(VListItemSubtitle, [_vm._v(_vm._s(data.item.descr))])], 1)];
      }
    }]),
    model: {
      value: _vm.selectedDpTypeObject,
      callback: function ($$v) {
        _vm.selectedDpTypeObject = $$v;
      },
      expression: "selectedDpTypeObject"
    }
  }), _c(VTextField, {
    staticClass: "mt-4",
    attrs: {
      "disabled": !_vm.dataPoint.device.id,
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.deadBand'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "type": "number",
      "min": "0",
      "oninput": "validity.valid||(value='')"
    },
    on: {
      "input": function ($event) {
        return _vm.convertToNumber('db');
      }
    },
    model: {
      value: _vm.dataPoint.db,
      callback: function ($$v) {
        _vm.$set(_vm.dataPoint, "db", $$v);
      },
      expression: "dataPoint.db"
    }
  })], 1)], 1), _c(VCardActions, [_c('core-button', {
    attrs: {
      "color": _vm.color
    },
    on: {
      "click": _vm.closeDpDialogWithoutSaving
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.cancel')) + "\n            ")]), _c('core-button', {
    attrs: {
      "color": _vm.color,
      "disabled": !_vm.dpValidation() || !_vm.isDpFormValid
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.ok')) + "\n            ")]), _c(VSpacer)], 1)], 1)], 1), _vm.showAddressCalculator ? _c(VCol, {
    attrs: {
      "cols": 6
    }
  }, [_c(VCard, [_c(VCardTitle, {
    staticClass: "text-h5"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.structuredDpAddress')) + "\n          ")]), _vm.calculator.type ? _c(VCardText, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.result')) + " (" + _vm._s(_vm.calculator.type.toUpperCase()) + "):\n            " + _vm._s(_vm.calculator[_vm.calculator.type].result) + "\n            "), _c(VCheckbox, {
    staticClass: "pt-0 mt-0",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.lowHighBytes'),
      "color": _vm.color,
      "hide-details": ""
    },
    on: {
      "change": function ($event) {
        return _vm.calculateAddress();
      }
    },
    model: {
      value: _vm.calculator[_vm.calculator.type].lowHighBytes,
      callback: function ($$v) {
        _vm.$set(_vm.calculator[_vm.calculator.type], "lowHighBytes", $$v);
      },
      expression: "calculator[calculator.type].lowHighBytes"
    }
  }), _vm._l(_vm.calculator[_vm.calculator.type].bytes, function (byteNumber) {
    return _c(VTextField, {
      key: byteNumber,
      staticClass: "mt-4",
      attrs: {
        "label": _vm.byteLable(byteNumber),
        "type": "number",
        "min": "0",
        "oninput": "validity.valid||(value='')",
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "hide-details": "auto"
      },
      on: {
        "input": function ($event) {
          return _vm.calculateAddress();
        }
      },
      model: {
        value: _vm.calculator[_vm.calculator.type].input[byteNumber - 1],
        callback: function ($$v) {
          _vm.$set(_vm.calculator[_vm.calculator.type].input, byteNumber - 1, $$v);
        },
        expression: "calculator[calculator.type].input[byteNumber - 1]"
      }
    });
  })], 2) : _vm._e(), _c(VCardActions, [_c('core-button', {
    attrs: {
      "color": _vm.color
    },
    on: {
      "click": function ($event) {
        return _vm.toggleAddressCalculator(_vm.calculator.type);
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.cancel')) + "\n            ")]), _c('core-button', {
    attrs: {
      "color": _vm.color
    },
    on: {
      "click": function ($event) {
        return _vm.setAsAddress(_vm.calculator.type);
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.setAsAddress')) + "\n            ")]), _c(VSpacer)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };